import { render, staticRenderFns } from "./shift-working-hour.vue?vue&type=template&id=0b90b82b&"
import script from "./shift-working-hour.vue?vue&type=script&lang=js&"
export * from "./shift-working-hour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports